import React, { useState } from 'react';
import Helmet from 'react-helmet';

export default props => {
	const lang = props.pageContext.lang || '';
	const [meta] = useState(require(`data/${lang}_meta`));

	const getTitle = () => {
		let title = meta.title;
		if (props.title) {
			title = `${props.title} @ ${meta.title}`;
		}
		return title;
	};

	const getUrl = () => {
		let url = meta.domain + '/' + lang;
		if (props.url) {
			url = url + props.url;
		}
		return url;
	};

	const getDescription = () => {
		let description = meta.description;
		if (props.description) {
			description = props.description;
		}
		return description;
	};

	const getImage = () => {
		let image = `${meta.domain}/static/${lang}_1200x628.png?t=${new Date().getTime()}`;
		if (props.image) {
			image = props.image;
		}
		return image;
	};

	const getKeywords = () => {
		let keywords = meta.keywords.map((item, index) => item.item);
		if (props.keywords) {
			keywords = [...props.keywords, ...keywords];
		}
		return keywords.join(', ');
	};

	return (
		<Helmet>
			<title>{getTitle()}</title>
			<link hreflang="x-default" rel="alternate" href={getUrl()} />
			<link hreflang="en" rel="alternate" href={getUrl()} />
			<meta itemprop="name" content={getTitle()} />
			<meta itemprop="description" content={getDescription()} />
			<meta itemprop="image" content={getImage()} />
			<meta name="description" content={getDescription()} />
			<meta name="keywords" content={getKeywords()} />
			<meta name="image" content={getImage()} />
			<meta name="twitter:card" content="summary" />
			<meta name="twitter:title" content={getTitle()} />
			<meta name="twitter:description" content={getDescription()} />
			<meta name="twitter:image:src" content={getImage()} />
			<meta property="og:title" content={getTitle()} />
			<meta property="og:description" content={getDescription()} />
			<meta property="og:image" content={getImage()} />
			<meta property="og:url" content={getUrl()} />
			<meta property="og:site_name" content={getTitle()} />
			<meta property="og:type" content="website" />
		</Helmet>
	);
};
